export default "__VITE_ASSET__CpCBBQqz__"